import { render, staticRenderFns } from "./SmallScreenWarning.vue?vue&type=template&id=1722a592&"
import script from "./SmallScreenWarning.vue?vue&type=script&lang=js&"
export * from "./SmallScreenWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports